<template>
  <div class="tonnage-summary">
    <h4>Total producciones</h4>
    <div class="tonnage-display">
      <span class="tonnage-value">{{ formattedKilograms }} kgs</span>
      <small class="tonnage-count">({{ eventCount }} eventos)</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TonnageSummary',
  props: {
    totalTonnage: {
      type: Number,
      default: 0,
    },
    eventCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    totalKilograms() {
      const kilograms = (this.totalTonnage || 0) * 1000;
      if (!Number.isFinite(kilograms)) return 0;
      // Always round up to avoid losing fractional kilos.
      return Math.ceil(kilograms);
    },
    formattedKilograms() {
      return new Intl.NumberFormat('es-CL').format(this.totalKilograms);
    },
  },
};
</script>

<style scoped>
.tonnage-summary {
  margin-top: 2rem;
  padding: 1rem;
  background: #fff;
  border: 1px solid #d3d8dc;
  border-radius: 0;
  position: sticky;
  top: 0;
  z-index: 10;
  width: 270px;
  font-family: 'Source Sans Pro', sans-serif;
}

.tonnage-summary h4 {
  margin: 0 0 0.75rem 0;
  font-size: 1em;
  font-weight: bold;
  color: #4e4e51;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: 'Source Sans Pro', sans-serif;
}

.tonnage-display {
  text-align: center;
}

.tonnage-value {
  display: block;
  font-size: 1.5rem;
  font-weight: bold;
  color: #28a745;
  margin-bottom: 0.25rem;
  font-family: 'Source Sans Pro', sans-serif;
}

.tonnage-count {
  color: #6c757d;
  font-size: 0.8rem;
  font-family: 'Source Sans Pro', sans-serif;
}
</style>
